import React from "react";
import { useTranslation } from "react-i18next";
import { convertTextStyle } from "src/util/TextFormatter";

type Props = {
  lastmessage: string;
  lastmessagetype: string;
  id?: string;
};

const ChatLastMessage: React.FC<Props> = ({
  lastmessage,
  lastmessagetype,
  id,
}) => {
  const { t } = useTranslation();

  let unsupportedMessage = t("HC.Error.Unsupportedmsg");
  let message = convertTextStyle(lastmessage);

  if (lastmessage.length > 47) {
    message = message.substring(0, 42) + " ...";
  }
  if (lastmessagetype === "text") {
    return (
      <div
        id={id}
        style={{
          color: message.includes("Draft : ") === true ? "red" : "grey",
        }}
        dangerouslySetInnerHTML={{ __html: convertTextStyle(message) }}
      ></div>
    );
  } else if (
    lastmessagetype === "image" ||
    lastmessagetype === "image_with_text"
  ) {
    return (
      <div>
        <span
          id={id}
          data-testid={id}
          className="bi bi-camera-fill pe-1"
        ></span>
        <span>
          {lastmessagetype === "image_with_text" && message
            ? convertTextStyle(message)
            : convertTextStyle(t("AddNewProduct.Title.Photo"))}
        </span>
      </div>
    );
  } else if (lastmessagetype === "video") {
    return (
      <div>
        <span
          id={id}
          data-testid={id}
          className="bi bi-camera-video-fill pe-1"
        ></span>
        <span>{convertTextStyle(t("HC.File.Type.video"))}</span>
      </div>
    );
  } else if (lastmessagetype === "audio") {
    return (
      <div>
        <span id={id} data-testid={id} className="bi bi-mic-fill pe-1"></span>
        <span>{convertTextStyle(t("HC.File.Type.audio"))}</span>
      </div>
    );
  } else if (lastmessagetype === "document") {
    return (
      <div>
        <span
          id={id}
          data-testid={id}
          className="bi bi-file-earmark-fill pe-1"
        ></span>
        <span>{convertTextStyle(t("HC.File.Type.document"))}</span>
      </div>
    );
  } else if (lastmessagetype === "order") {
    return (
      <div>
        <span
          id={id}
          data-testid={id}
          className="bi bi-file-earmark-fill pe-1"
        ></span>
        <span>{convertTextStyle(t("Menu.Order"))}</span>
      </div>
    );
  } else if (lastmessagetype === "product") {
    return (
      <div>
        <span
          id={id}
          data-testid={id}
          className="bi bi-file-earmark-fill pe-1"
        ></span>
        <span>{convertTextStyle(t("Storefront.Column.Product"))}</span>
      </div>
    );
  } else if (lastmessagetype === "location") {
    return (
      <div>
        <span
          id={id}
          data-testid={id}
          className="bi bi-geo-alt-fill pe-1"
        ></span>
        <span
          dangerouslySetInnerHTML={{
            __html: convertTextStyle(t("HandledCustomer.Attachment.Location")),
          }}
        />
      </div>
    );
  } else if (lastmessagetype === "unsupported") {
    return (
      <div>
        <span id={id} data-testid={id} className="bi bi-clock-fill pe-1"></span>
        <span
          dangerouslySetInnerHTML={{
            __html: convertTextStyle(t("HC.Error.Unsupportedmsg")),
          }}
        />
      </div>
    );
  } else if (lastmessagetype === "sticker") {
    return (
      <div>
        <span
          id={id}
          data-testid={id}
          className="bi bi-emoji-smile pe-1"
        ></span>
        <span
          dangerouslySetInnerHTML={{
            __html: convertTextStyle(t("HC.File.Type.sticker")),
          }}
        />
      </div>
    );
  } else {
    return (
      <div dangerouslySetInnerHTML={{ __html: convertTextStyle(message) }} />
    );
  }
};

export { ChatLastMessage };
